module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-opened-2c27dd41e5916062c70dbcc6a6479ca5.svg";